import { SimpleGrid } from "@chakra-ui/layout";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import colors from "core/resources/theme/colors";
import {
  AiOutlineFall,
  AiOutlineRise,
  AiOutlineRedo,
  AiOutlineClose,
} from "react-icons/ai";
import { AcordosDashboard } from "core/features/acordo/typings";
import { AcordoStatus } from "core/features/acordo/enums";

interface DahsboardAcordosProps {
  data?: AcordosDashboard;
  isLoading?: boolean;
  onCardClick?: (status?: AcordoStatus) => void;
}

function DashboardAcordos({
  data,
  isLoading,
  onCardClick,
}: DahsboardAcordosProps) {
  return (
    <SimpleGrid mt="16px" columns={5} gap="16px">
      <Card1Horizontal
        bg={colors.green100}
        title={`${data?.pagos ? data?.pagos : 0}`}
        icon={<AiOutlineRise fontSize="24px" color={colors.green} />}
        color={colors.green}
        description="Pagos"
        loading={isLoading}
        onClick={() => onCardClick?.(AcordoStatus.Pago)}
      />

      <Card1Horizontal
        bg={colors.blue100}
        title={`${data?.emAberto ? data?.emAberto : 0}`}
        icon={<AiOutlineFall fontSize="24px" color={colors.blue} />}
        description="Em Aberto"
        color={colors.blue}
        loading={isLoading}
        onClick={() => onCardClick?.(AcordoStatus.EmAberto)}
      />

      <Card1Horizontal
        bg={colors.red100}
        title={`${data?.cancelados ? data?.cancelados : 0}`}
        icon={<AiOutlineFall fontSize="24px" color={colors.red} />}
        color={colors.red}
        description="Cancelados"
        loading={isLoading}
        onClick={() => onCardClick?.(AcordoStatus.Cancelado)}
      />

      <Card1Horizontal
        bg={colors.gray50}
        title={`${data?.renegociados ? data?.renegociados : 0}`}
        icon={<AiOutlineRedo fontSize="24px" color={colors.darkGray} />}
        description="Renegociados"
        loading={isLoading}
        color={colors.gray}
        onClick={() => onCardClick?.(AcordoStatus.Renegociado)}
      />

      <Card1Horizontal
        bg={colors.gray50}
        title={`${data?.encerrados ? data?.encerrados : 0}`}
        icon={<AiOutlineClose fontSize="24px" color={colors.darkGray} />}
        description="Encerrados"
        loading={isLoading}
        color={colors.gray}
        onClick={() => onCardClick?.(AcordoStatus.Encerrado)}
      />
    </SimpleGrid>
  );
}

export default DashboardAcordos;
